// @flow
/* eslint no-irregular-whitespace: 0 */

// NOTE:
// app/models/resolution/content_template.rbの定義を参照
// 従って、内容を修正する場合は上記ファイルも同時に修正が必要
export const resolutionContentTemplates = [
  {
    id: 1,
    resolutionCategoryId: 16,
    content: `　当社は、会社法第361条の規定に基づき、当社取締役の業績向上に対する意欲や士気を一層高めることにより、当社の健全な経営と社会的信頼の向上を図ることを目的として、第２号議案で付議するストック・オプションを当社取締役に付与するために、従来ご承認いただいた報酬額とは別枠で、当社取締役に対し{{年額●万円}}の範囲でストック・オプション報酬として新株予約権を発行することにつきご承認をお願いするものであります。
    　ストック・オプションとして付与される報酬額及び新株予約権の具体的な内容は、当社と同程度の事業規模や業種に属する企業の報酬水準を参考に当社の経営体制の状況、経済情勢等、諸般の事情を鑑み決定しており、相当なものであると判断しております。
    　なお、本議案の対象となる取締役は{{・・・名}}となります。
    　ストック・オプション報酬として当社取締役に対して付与する新株予約権の内容は次のとおりであります。

    １．特に有利な条件をもって新株予約権を発行する理由
    当社取締役の業績向上に対する意欲や士気を一層高めることにより、当社の健全な経営と社会的信頼の向上を図ることを目的として、当社の取締役に対し、金銭の払い込みを要することなく新株予約権を割り当てるものであります。
    ２．新株予約権の数の上限
    　　別紙Aのとおり
    ３．新株予約権と引換えに払い込む金銭
    　　別紙Aのとおり
    ４．新株予約権の内容
    　　別紙Aのとおり`,
  },
  {
    id: 2,
    resolutionCategoryId: 17,
    content: `当社は、◯◯◯◯◯◯を目的として、会社法第200条第1項の定めに基づき本総会終結のときから◯◯年◯◯月◯◯日までに、今後の取締役会の決議により当社普通株式を下記の範囲内で発行することにつきご承認をお願いするものであります。

    　　　　　　　　　　　　　　　記

    (1) 募集株式の数の上限       　              ◯◯◯，◯◯◯株
    (2) 募集株式の払込金額の下限      1株につき    金◯，◯◯◯円`,
  },
  {
    id: 3,
    resolutionCategoryId: 18,
    content: `　取締役全員(○名)は、本総会終結の時をもって任期満了となりますので、取締役○名の選任をお願いいたしたいと存じます。 取締役候補者は次のとおりであります。

    　■氏名（生年月日）
    　　XXXX（○○○○年○○月○○日）
    　■略歴、地位、担当
    　　○年○月      当社入社
    　　○年○月      当社○○部長
    　　○年○月      当社取締役（営業本部担当）
    　　○年○月      当社常務取締役
    　　　　　　　現在に至る
    　■重要な兼職の状況
    　　XXXX
    　■所有する当社の株式数
    　　○○○株
    　■社外取締役候補者とした理由及び期待される役割の概要
    　　XXXX

    (注)１．各候補者と当社との間に特別の利害関係はありません。
    ２．〇〇〇〇、××××の両氏は社外取締役候補者であります。
    ３．〇〇〇〇氏を社外取締役候補者とした理由は、･･･。
    ４．××××氏を社外取締役候補者とした理由は、･･･。
    ５．当社は社外取締役が期待される役割を十分発揮できるよう、現行定款第●条において、社外取締役との間で任務を怠ったことによる損害賠償責任を限定する契約を締結できる旨を定めております。これにより、××××氏は、当社との間で法令に定める額を限度として賠償責任を限定する責任限定契約を締結しており、同氏の再任が承認された場合、上記責任限定契約を継続する予定です。また、社外取締役候補者である〇〇〇〇氏の選任が承認された場合、当社との間で上記と同じ責任限定契約を締結する予定であります。
    【締結対象：非業務執行取締役】
    ６．△△△△氏と××××氏は、当社と会社法第430条の2第1項に規定する補償契約を締結しております。当該契約では、同項第１号の費用および同項第2号の損失を法令の定める範囲内において、当社が補償することとしております。両氏の選任が承認された場合、当社は両氏との間で、引き続き本契約を継続する予定であります。また、〇〇〇〇氏の選任が承認された場合、当社は同氏との間で上記補償契約を締結する予定であります。【締結対象：全取締役】
    ７．当社は、会社法第430条の3第1項に規定する役員等賠償責任保険契約を保険会社との間で締結し、被保険者が負担することになる損害賠償金および争訟費用等の損害を当該保険契約により塡補することとしております。各候補者は、当該保険契約の被保険者に含まれることとなります。なお当該契約の保険料は、当社が全額負担しております。【締結対象：全取締役】
    ８．〇〇〇〇氏には、…や…といった経験を生かし、当社において、主に…を果たしていただくことを期待しております。
    ９．××××氏には、…や…といった経験を生かし、当社において、主に…を果たしていただくことを期待しております。`,
  },
  {
    id: 4,
    resolutionCategoryId: 19,
    content: `
    監査役全員（◯名）は、本総会の終結の時をもって任期満了となりますので、監査役◯名の選任をお願いいたしたいと存じます。なお、本議案に関しましては、監査役（会）の同意を得ております。
    監査役候補者は、次のとおりであります。


    　■氏名（生年月日）
    　　XXXX（○○○○年○○月○○日）
    　■略歴、地位、担当
    　　○年○月      当社入社
    　　○年○月      当社○○部長
    　　○年○月      当社取締役（営業本部担当）
    　　○年○月      当社常務取締役
    　　　　　　　現在に至る
    　■重要な兼職の状況
    　　XXXX
    　■所有する当社の株式数
    　　○○○株
    　■社外監査役候補者とした理由及び期待される役割の概要
    　　XXXX




    （※以下注書きは該当部分を記載）
    （注）１. ◯◯　◯◯は、新任の監査役候補者であります。
    ２. 各候補者との間には特別の利害関係はありません。
    ３. ◯◯　◯◯氏は、社外監査役候補者であります。
    ４. ◯◯　◯◯氏は、現在、当社の社外監査役でありますが、社外監査役としての在任期間は、本総会終結の時をもって◯年となります。
    ５. 当社は、◯◯　◯◯氏との間で会社法第430条の２第１項に規定する同項第１号の費用及び同項第２号の損失を法令の定める範囲内において当社が補償する内容の補償契約を締結しております。◯◯　◯◯氏の再任が承認された場合には、当社は当該補償契約を継続する予定であります。
    ６. 当社は、会社法第430条の３第１項に規定する役員等賠償責任保険契約を保険会社との間で締結しており、被保険者が負担することとなる損害賠償金及び争訟費用等の損害を填補することとしております。第◯号議案の承認可決を条件として、各候補者は、当該保険契約の被保険者に含められることとなります。また、次回更新時には同内容での更新を予定しております。
    ７．当社は、◯◯　◯◯氏との間で会社法第427条第１項の規定に基づき、同法第423条第１項の損害賠償責任を限定する契約を締結しております。当該契約に基づく損害賠償責任の限度額は、会社法第425条第１項に定める最低責任限度額としております。◯◯　◯◯氏の再任が承認された場合には、当社は当該責任限定契約を継続する予定であります。
    ８．当社は、◯◯　◯◯氏を東京証券取引所の定めに基づく独立役員として届け出ております。`,
  },
  {
    id: 5,
    resolutionCategoryId: 20,
    content: `
    　当社は、コーポレート・ガバナンスの一層の強化を図るため、第◯号議案が承認可決されることを条件に、会計監査人設置会社となります。つきましては、会計監査人の選任をお願いするものであります。
    　なお、本議案につきましては、監査役会の決定に基づいております。
    　監査役会が◯◯監査法人を会計監査人の候補者としてた理由は、◯◯◯◯◯◯◯◯◯◯◯であります。
    　会計監査人候補者は次のとおりであります。

    　■名称
    　　XXXX
    　■事務所
    　　XXXX
    　■沿革
    　　XXXX
    　■概要（資本金、構成人員等）
    　　XXXX

    （※以下注書きは該当部分を記載）
    （注）１．会計監査人候補者は、過去２年間に当社（または当社の親会社、子会社、親会社等の子会社）より、◯◯◯業務に係る報酬を受けており、今後も受ける予定があります。
    ２．◯◯監査法人が選任された場合、当社は同法人との間で会社法第427条第１項の規定に基づき、同法第423条第１項の損害賠償責任を限定する契約を締結する予定であります。当該契約に基づく損害賠償責任の限度額は、会社法第425条第１項に定める最低責任限度額としております。
    ３．◯◯監査法人が選任された場合、会社法第430条の２第１項に規定する同項第１号の費用及び同項第２号の損失を法令の定める範囲内において当社が補償する内容の補償契約を締結する予定であります。（ただし、◯◯◯の場合を除く。）
    ４． 当社は、会社法第430条の３第１項に規定する役員等賠償責任保険契約を保険会社との間で締結しており、被保険者が負担することとなる損害賠償金及び争訟費用等の損害を填補することとしております。（ただし、◯◯◯の場合を除く。）会計監査人候補者である◯◯監査法人が会計監査人に就任した場合は、当該保険契約の被保険者に含められることとなります。また、次回更新時には同内容での更新を予定しております。`,
  },
  {
    id: 6,
    resolutionCategoryId: 21,
    content: `
    監査等委員である取締役全員（◯名）は、本総会の終結の時をもって任期満了となりますので、監査等委員である取締役◯名の選任をお願いいたしたいと存じます。なお、本議案に関しましては、監査等委員会の同意を得ております。
    監査等委員である取締役候補者は、次のとおりであります。

    　■氏名（生年月日）
    　　XXXX（○○○○年○○月○○日）
    　■略歴、地位、担当
    　　○年○月      当社入社
    　　○年○月      当社○○部長
    　　○年○月      当社取締役（営業本部担当）
    　　○年○月      当社常務取締役
    　　　　　　　現在に至る
    　■重要な兼職の状況
    　　XXXX
    　■所有する当社の株式数
    　　○○○株
    　■社外取締役候補者とした理由及び期待される役割の概要
    　　XXXX

    （※以下注書きは該当部分を記載）
    （注）１. ◯◯　◯◯は、新任の取締役候補者であります。
    ２. 各候補者との間には特別の利害関係はありません。
    ３. ◯◯　◯◯氏は、社外取締役候補者であります。
    ４. ◯◯　◯◯氏は、現在、当社の社外取締役でありますが、社外取締役としての在任期間は、本総会終結の時をもって◯年となります。
    ５. 当社は、◯◯　◯◯氏との間で会社法第430条の２第１項に規定する同項第１号の費用及び同項第２号の損失を法令の定める範囲内において当社が補償する内容の補償契約を締結しております。◯◯　◯◯氏の再任が承認された場合には、当社は当該補償契約を継続する予定であります。
    ６. 当社は、会社法第430条の３第１項に規定する役員等賠償責任保険契約を保険会社との間で締結しており、被保険者が負担することとなる損害賠償金及び争訟費用等の損害を填補することとしております。第◯号議案の承認可決を条件として、各候補者は、当該保険契約の被保険者に含められることとなります。また、次回更新時には同内容での更新を予定しております。
    ７．当社は、◯◯　◯◯氏との間で会社法第427条第１項の規定に基づき、同法第423条第１項の損害賠償責任を限定する契約を締結しております。当該契約に基づく損害賠償責任の限度額は、会社法第425条第１項に定める最低責任限度額としております。◯◯　◯◯氏の再任が承認された場合には、当社は当該責任限定契約を継続する予定であります。
    ８．当社は、◯◯　◯◯氏を東京証券取引所の定めに基づく独立役員として届け出ております。`,
  },
  {
    id: 7,
    resolutionCategoryId: 22,
    content: `
    会社法第156条第1項の規定に基づき、本総会終結の時から1年以内に当社普通株式◯◯◯◯株、株式を取得するのと引換えに交付する金銭の総額◯◯◯◯円を限度として、自己の株式取得につき下記記載の株主に取得の通知を行い、取得することといたしたいと存じます。
    なお、本件に関し、会社法第160条第3項の規定に基づき、株主の皆様は自己を特定の株主に追加することを請求することができます。他の株主から本総会会日の5日前（※非公開会社かつ書面投票制度採用でない場合は3日前）までに書面をもって売主として追加の申出があったときは、上記の株式数、株式を取得するのと引換えに交付する金銭の総額の範囲内において、その株主からも追加取得するものといたしたいと存じます。
    売却申出株式数の総数が◯◯◯◯株を超過する場合には、会社法第159条第2項の規定に基づき、売却申出株式数による比例按分とさせていただきます。

    　　　　　　　　　　　　　　　　　　　　　記

    　　　　　　　　　　株主名◯◯◯◯◯、株主名◯◯◯◯◯、株主名◯◯◯◯◯`,
  },
  {
    id: 8,
    resolutionCategoryId: 23,
    content: `
    1.変更の理由
    　株式事務の合理化および株式流通の安全を図ることを目的として、株券不発行会社に移行するため、現行定款第◯条（株券の発行）を削除し、株券喪失登録簿に関する経過措置について、附則を設けるものであります。現行定款第◯条の削除に伴い、変更案第◯条（株主名簿管理人）および変更案第◯条（株式取扱規則）に所要の変更を行うものであります。
    2.変更の内容
    　変更の内容は別紙の通りであります。
    ※（補足）定款変更前後の対照表は添付資料としてアップロードしてください。
    （※は確認後削除願います）`,
  },
  {
    id: 9,
    resolutionCategoryId: 24,
    content: `
    1.変更の理由
    　◯◯を目的として、株券発行会社に移行するため、定款第◯条（株券の発行）を設けるものであります。
    2.変更の内容
    　変更の内容は別紙の通りであります。
    ※（補足）定款変更前後の対照表は添付資料としてアップロードしてください。
    （※は確認後削除願います）`,
  },
  {
    id: 10,
    resolutionCategoryId: 25,
    content: `
    当社の第◯期事業年度における計算書類につきましては、◯年◯月◯日開催の当社第◯期定時株主
    総会において承認可決いただいておりますが、会社計算規則および会社法施行規則ならびに金融商品
    取引法に基づく開示との整合性の一部に不備が生じており、内容を検討した結果、下記のとおり修正
    することにつき、ご承認をお願いするものであります。修正後の内容は、「修正損益計算書」のとお
    りであります。

    　　　　　　　　　　　　　　　　　　　　　　記

    １．固定資産の減損処理から会計上の見積り変更に伴う償却処理への修正
    ２．◯◯◯◯◯◯◯◯◯◯◯◯
    ３．◯◯◯◯◯◯◯◯◯◯◯◯
    ４．◯◯◯◯◯◯◯◯◯◯◯◯`,
  },
  {
    id: 11,
    resolutionCategoryId: 43,
    content: `当社は、会社法第236条、第238条及び第239条の規定に基づき、当社の取締役及び従業員に対してストック・オプションとして新株予約権を発行すること及びその募集事項の決定を取締役会に委任することにつきご承認をお願いするものであります。

    １．特に有利な条件をもって新株予約権を発行する理由
    　　当社の取締役及び従業員の業績向上に対する意欲や士気を一層高めることにより、当社の健全な経営と社会的信頼の向上を図ることを目的として、当社の取締役及び従業員に対し、金銭の払い込みを要することなく新株予約権を割り当てるものであります。
    ２．新株予約権の数の上限
    　　別紙Aのとおり
    ３．新株予約権と引換えに払い込む金銭
    　　別紙Aのとおり
    ４．新株予約権の内容
    　　別紙Aのとおり`,
  },
  {
    id: 12,
    resolutionCategoryId: 59,
    content: `当社は、会社法第236条、第238条及び第239条の規定に基づき、当社の従業員に対してストック・オプションとして新株予約権を発行すること及びその募集事項の決定を取締役会に委任することにつきご承認をお願いするものであります。

    １．特に有利な条件をもって新株予約権を発行する理由
    　　当社の従業員の業績向上に対する意欲や士気を一層高めることにより、当社の健全な経営と社会的信頼の向上を図ることを目的として、当社の従業員に対し、金銭の払い込みを要することなく新株予約権を割り当てるものであります。
    ２．新株予約権の数の上限
    　　別紙Aのとおり
    ３．新株予約権と引換えに払い込む金銭
    　　別紙Aのとおり
    ４．新株予約権の内容
    　　別紙Aのとおり`,
  },
];
